import api from '../token';

export const ListFornecedor = async () => {
  try {
    const response = await api.post('/getFornecedor');
    return response.data;
  } catch (error) {
   
    return [];
  }
};

